export type EmployeeFeedbackInsightType = 'critical' | 'warning' | 'positive' | 'info';

export type EmployeeFeedbackInsightCategory =
  | 'OnlyNegative'
  | 'NoFeedback'
  | 'ManagerNoFeedback'
  | 'OnlyPositive';

export interface EmployeeFeedbackInsightModel {
  type: EmployeeFeedbackInsightType;
  category: EmployeeFeedbackInsightCategory;
  prefix: string;
  highlight: string;
  suffix: string;
  icon: string;
  iconColor: string;
  iconBackground: string;
}

export interface EmployeeFeedbackInsightsResponse {
  items: EmployeeFeedbackInsightModel[];
}

export interface EmployeeFeedbackInsightCategoryInfo {
  category: EmployeeFeedbackInsightCategory;
  icon: string;
  iconColor: string;
  iconBackground: string;
  title: string;
  description: string;
}

export const EMPLOYEE_FEEDBACK_INSIGHT_CATEGORIES: EmployeeFeedbackInsightCategoryInfo[] = [
  {
    category: 'OnlyNegative',
    icon: 'frown',
    iconColor: '#ea5455',
    iconBackground: '#fceaea',
    title: 'Colaboradores recebendo somente feedbacks negativos',
    description: 'Pode indicar baixo desempenho ou gestor não aplicando feedback de forma equilibrada',
  },
  {
    category: 'NoFeedback',
    icon: 'bell',
    iconColor: '#ff9f43',
    iconBackground: '#fff3e8',
    title: 'Colaboradores sem receber nenhum feedback',
    description: 'Ex.: "Luíza não recebe feedback há 3 meses"',
  },
  {
    category: 'ManagerNoFeedback',
    icon: 'users',
    iconColor: '#00cfe8',
    iconBackground: '#e8fafe',
    title: 'Gestores sem registrar nenhum feedback para a equipe',
    description: 'Ex.: "Gestor Edson não registrou feedback há 3 meses"',
  },
  {
    category: 'OnlyPositive',
    icon: 'smile',
    iconColor: '#28c76f',
    iconBackground: '#e8f8ef',
    title: 'Colaboradores recebendo somente feedbacks positivos',
    description: 'Pode indicar excelência ou gestor não sendo criterioso na avaliação',
  },
];

export function mapEmployeeFeedbackInsight(item: any): EmployeeFeedbackInsightModel {
  const type = (item?.type ?? item?.Type ?? 'info') as EmployeeFeedbackInsightType;
  const category = (item?.category ?? item?.Category ?? 'OnlyNegative') as EmployeeFeedbackInsightCategory;

  return {
    type,
    category,
    prefix: item?.prefix ?? item?.Prefix ?? '',
    highlight: item?.highlight ?? item?.Highlight ?? '',
    suffix: item?.suffix ?? item?.Suffix ?? '',
    ...getInsightVisuals(type),
  };
}

function getInsightVisuals(type: EmployeeFeedbackInsightType): Pick<
  EmployeeFeedbackInsightModel,
  'icon' | 'iconColor' | 'iconBackground'
> {
  switch (type) {
    case 'critical':
      return {
        icon: 'alert-circle',
        iconColor: '#f87171',
        iconBackground: '#ffebeb',
      };
    case 'warning':
      return {
        icon: 'alert-triangle',
        iconColor: '#fb923c',
        iconBackground: '#fff3e0',
      };
    case 'positive':
      return {
        icon: 'smile',
        iconColor: '#4ade80',
        iconBackground: '#e8f5e9',
      };
    default:
      return {
        icon: 'info',
        iconColor: '#00cfe8',
        iconBackground: '#e8fafe',
      };
  }
}
